<template>
  <div class="container-withdraw-account" :class="[packageName]">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.wd.withdrawAccount') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 图标 -->
      <div class="account-tit">
        <div class="account-img">
          <img :src="icon | imgPath" alt="" />
        </div>
        <span class="line"></span>
        <div class="account-name">{{ withdrawalMethod }}</div>
      </div>

      <!-- 提现名 -->
      <div class="select">
        <span>{{ $t('lang.wd.cc') }}</span>
        <div class="country">
          <img :src="locaFlag | imgPath" alt="" />
          <div class="account-name">{{ locaCode }}</div>
        </div>
      </div>

      <!-- 否则 -->
      <div class="select">
        <span>{{ $t('lang.wd.name') }}</span>
        <input style="color: #333" type="text" :placeholder="$t('lang.wd.phYourName')" v-model.trim="accountName" />
      </div>

      <div class="select">
        <span type="text">{{ $t('lang.wd.TRC20Account') }}</span>
        <div class="select-account">
          <div class="TRC20-box">
            <input maxlength="34" type="text" :placeholder="$t('lang.wd.TRC20Account')" v-model="accountId" />
            <div class="TRC20-length-tip">{{ accountId.length }}/34</div>
          </div>
        </div>

        <!-- 输入框下面的提示 -->
        <div class="tipTRC20">
          <div>* {{ $t('lang.wd.TRC20Tip1') }}</div>
          <div>* {{ $t('lang.wd.TRC20Tip2') }}</div>
        </div>
      </div>

      <!-- 保存按钮 -->
      <div class="save-btn" :class="{ 'save-btn-act': this.saveFlag() }" @click="handleSave">
        {{ cfgId ? $t('lang.change') : $t('lang.wd.save') }}
      </div>
    </div>
  </div>
</template>

<script>
import { apiBindWithdrawAccount, apiEditWithdrawAccount } from '@/api/imee.js'

import _debounce from 'lodash/debounce'
import baseMixin from '../base.mixin.js'

export default {
  mixins: [baseMixin],
  data() {
    return {}
  },
  methods: {
    // 保存
    handleSave: _debounce(
      function () {
        // 去掉空格
        const strAccountId = `${this.accountId}`
        this.accountId = strAccountId.replace(/\s*/g, '')

        const data = {
          accountId: this.accountId,
          accountName: this.accountName
        }

        // 判断emoji表情
        if (this.hasEmojiCharacter(this.accountName)) {
          this.accountName = ''
          this.$client.showToast(this.$t('lang.wd.emojiTip'))
          return
        }

        // 如果是USDT(TRC20)
        if (this.withdrawalMethod === 'USDT(TRC20)') {
          if (this.accountId.length !== 34) {
            this.accountId = ''
            this.$client.showToast(this.$t('lang.wd.TRC20WrongTip'))
            return
          }
        }

        // edit
        if (this.cfgId) {
          apiEditWithdrawAccount(data, this.cfgId).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
        // add
        else {
          data.withdrawalMethod = this.withdrawalMethod
          apiBindWithdrawAccount(data).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
      },
      3000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 保存校验
    saveFlag() {
      if (this.accountId && this.accountName) {
        return true
      }
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../base.scss';
</style>
